import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
// import { Subscription, of } from 'rxjs';
// import { debounceTime, distinctUntilChanged, map, startWith, switchMap } from 'rxjs/operators';
import { Subscription, of, forkJoin } from 'rxjs'; // <--- Added forkJoin
import { debounceTime, distinctUntilChanged, map, startWith, switchMap, catchError } from 'rxjs/operators'; // <--- Added catchError
import { saveAs } from 'file-saver';

import WorkOrderService from 'src/app/services/WorkOrder';
import { ExportcsvService } from 'src/app/services/exportcsv.service';
import { SharedService } from 'src/app/shared/shared.service';
import { PAGE_VIEW_TYPE } from 'src/app/utility/Constants';
import { ProjectAndContractDetailsComponent } from 'src/app/pages/prn-entry/project_and_contract_details/project-and-contract-details/project-and-contract-details.component';

@Component({
  selector: 'app-dlp',
  templateUrl: './dlp-list.component.html',
  styleUrls: ['./dlp-list.component.scss']
})
export class DlpListComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;

  public displayedColumns = [
    'position',
    'action',
    'workOrderNo',
    'clientName',
    'siteName',
    'dlpApplicable',
    'dlpDuration',
    'dlpEndDate'
  ];

  availableColumns = [
    { value: 'position', viewValue: 'Sr. No.', selected: true },
    { value: 'action', viewValue: 'Action', selected: true },
    { value: 'workOrderNo', viewValue: 'Work Order No.', selected: true },
    { value: 'clientName', viewValue: 'Client Name', selected: true },
    { value: 'siteName', viewValue: 'Site Name', selected: true },
    { value: 'dlpApplicable', viewValue: 'DLP Applicable', selected: true },
    { value: 'dlpDuration', viewValue: 'DLP Duration', selected: true },
    { value: 'dlpEndDate', viewValue: 'DLP End Date', selected: true }
  ];

  dataSource = new MatTableDataSource<any>();

  // Access rights
  viewAccess: boolean = true;
  isLoading: boolean = false;
  isApiCalled: boolean = false;
  selectAllColumns: boolean = true;

  // Pagination & Filtering
  totalData: number = 0;
  searchControl = new FormControl('');
  clientFilterControl = new FormControl('');
  clientSearchFilter = new FormControl('');
  siteFilterControl = new FormControl('');

  clientOptions: string[] = [];
  filteredClientOptions: string[] = [];
  siteOptions: string[] = [];

  private allData: any[] = [];
  private subscription: Subscription;
  private clientNameMap = new Map<number, string>();
  private clientsLoaded = false;

  constructor(
    private _router: Router,
    private _snackBar: MatSnackBar,
    private _workOrderService: WorkOrderService,
    public dialog: MatDialog,
    private exportCsvService: ExportcsvService,
    private _sharedService: SharedService
  ) {
    this.viewAccess = localStorage.getItem('WOViewAccess') === 'true';
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.isApiCalled = false;

    // this.paginator.page
    //   .pipe(
    //     startWith({}),
    //     switchMap(() => {
    //       const params = {
    //         page: this.paginator.pageIndex + 1,
    //         size: this.paginator.pageSize,
    //         searchText: this.searchControl.value || ''
    //       };
    //       return this._workOrderService.getWorkOrdersByPageCount(params).pipe(
    //         switchMap((res) => this.loadClientNames().pipe(map(() => res)))
    //       );
    //     }),
    //     map((res: any) => {
    //       this.totalData = res.totalData;
    //       this.isApiCalled = true;
    //       return this.normalizeDlpData(res.data);
    //     })
    //   )
    //   .subscribe((data: any[]) => {
    //     this.allData = data;
    //     this.dataSource = new MatTableDataSource(data);
    //     this.populateFilterOptions(data);
    //     this.applyColumnFilters();
    //   });
    this.paginator.page
  .pipe(
    startWith({}),
    switchMap(() => {
      const params = {
        page: this.paginator.pageIndex + 1,
        size: this.paginator.pageSize,
        searchText: this.searchControl.value || ''
      };
      return this._workOrderService.getWorkOrdersByPageCount(params).pipe(
        switchMap((res) => this.loadClientNames().pipe(map(() => res)))
      );
    }),
    switchMap((res: any) => {
      this.totalData = res.totalData;
      this.isApiCalled = true;
      return this.normalizeDlpData(res.data); // Returns forkJoin Observable
    })
  )
  .subscribe((data: any[]) => {
    this.allData = data;
    this.dataSource = new MatTableDataSource(data);
    this.populateFilterOptions(data);
    this.applyColumnFilters();
  });

    // Search input listener
    this.subscription = this.searchControl.valueChanges
      .pipe(
        debounceTime(1000),
        distinctUntilChanged()
      )
      .subscribe((value) => {
        this.searchDlpData(0, value || '');
      });

    // Dropdown filters listeners
    this.clientFilterControl.valueChanges.subscribe(() => this.applyColumnFilters());
    this.siteFilterControl.valueChanges.subscribe(() => this.applyColumnFilters());

    this.clientSearchFilter.valueChanges.subscribe((search) => {
      const s = search?.toLowerCase() || '';
      this.filteredClientOptions = s
        ? this.clientOptions.filter((c) => c.toLowerCase().includes(s))
        : [...this.clientOptions];
    });
  }

  private loadClientNames() {
    if (this.clientsLoaded) {
      return of(void 0);
    }
    return this._sharedService.getClients().pipe(
      map((clients: any[] = []) => {
        this.clientNameMap = new Map(
          clients
            .filter((client) => client?.clientKey != null)
            .map((client) => [Number(client.clientKey), client.clientName || '-'])
        );
        this.clientsLoaded = true;
      })
    );
  }

  // private normalizeDlpData(data: any[] = []) {
  //   return (data || []).map((item) => ({
  //     ...item,
  //     siteName: item?.siteName || '-',
  //     clientName: item?.clientName || this.clientNameMap.get(Number(item?.clientKey)) || '-',
  //     dlpApplicable: item?.dlpApplicable ?? '-',
  //     dlpDuration: item?.dlpDuration || '-',
  //     dlpEndDate: item?.dlpEndDate || null
  //   }));
  // }

private normalizeDlpData(data: any[] = []) {
  const dlpRequests = (data || []).map((item) => {
    const targetId = item?.workOrderkey || item?.workOrderKey || item?.id;
    if (!targetId) return of(null);

    return this._workOrderService.getDlpByWorkorderId(targetId).pipe(
      catchError(() => of(null))
    );
  });

  return forkJoin(dlpRequests).pipe(
    map((dlpRecords: any[]) => {
      return (data || []).map((item, index) => {
        const dlp = dlpRecords[index];

        // Determine applicable value safely
        let isApplicable = '-';
        if (dlp) {
          if (dlp.dlpApplicable === true || dlp.dlpApplicable === 'Yes' || dlp.dlpApplicable === 'YES') {
            isApplicable = 'Yes';
          } else {
            isApplicable = 'No';
          }
        }

        return {
          ...item,
          workOrderNo: item?.workOrderNo || item?.workOrderNumber || '-',
          siteName: item?.siteName || '-',
          clientName: item?.clientName || this.clientNameMap.get(Number(item?.clientKey)) || '-',
          dlpApplicable: isApplicable,
          dlpDuration: dlp?.dlpDuration ? `${dlp.dlpDuration} Months` : '-',
          dlpEndDate: dlp?.dlpEndDate || null
        };
      });
    })
  );
}

  // searchDlpData(pageNumber: number, search: string) {
  //   this._workOrderService
  //     .getWorkOrdersByPageCount({
  //       page: pageNumber,
  //       limit: this.paginator.pageSize,
  //       searchText: search
  //     })
  //     .pipe(switchMap((res) => this.loadClientNames().pipe(map(() => res))))
  //     .subscribe({
  //       next: (res: any) => {
  //         const normalized = this.normalizeDlpData(res?.data);
  //         this.allData = normalized;
  //         this.dataSource.data = normalized;
  //         this.populateFilterOptions(normalized);
  //         this.totalData = res?.totalData;
  //         this.dataSource.paginator = this.paginator;
  //       },
  //       error: () => {}
  //     });
  // }

  searchDlpData(pageNumber: number, search: string) {
  this._workOrderService
    .getWorkOrdersByPageCount({
      page: pageNumber,
      limit: this.paginator.pageSize,
      searchText: search
    })
    .pipe(
      switchMap((res) => this.loadClientNames().pipe(map(() => res))),
      switchMap((res: any) => {
        this.totalData = res?.totalData;
        return this.normalizeDlpData(res?.data);
      })
    )
    .subscribe({
      next: (normalized: any[]) => {
        this.allData = normalized;
        this.dataSource.data = normalized;
        this.populateFilterOptions(normalized);
        this.dataSource.paginator = this.paginator;
      },
      error: () => {}
    });
}

  populateFilterOptions(data: any[]) {
    this.clientOptions = [...new Set(data.map((d) => d.clientName).filter(Boolean))].sort();
    this.siteOptions = [...new Set(data.map((d) => d.siteName).filter(Boolean))].sort();
    this.filteredClientOptions = [...this.clientOptions];
  }

  applyColumnFilters() {
    const client = this.clientFilterControl.value?.toLowerCase() || '';
    const site = this.siteFilterControl.value?.toLowerCase() || '';

    const filtered = this.allData.filter((row) => {
      const matchClient = !client || row.clientName?.toLowerCase().includes(client);
      const matchSite = !site || row.siteName?.toLowerCase() === site;
      return matchClient && matchSite;
    });

    this.dataSource = new MatTableDataSource(filtered);
  }

  toggleAllColumns(checked: boolean) {
    this.selectAllColumns = checked;
    this.availableColumns.forEach((col) => (col.selected = checked));
    this.updateDisplayedColumnsdropdown();
  }

  toggleColumn(column: { value: string; viewValue: string; selected: boolean }, checked: boolean) {
    column.selected = checked;
    this.updateDisplayedColumnsdropdown();
  }

  updateDisplayedColumnsdropdown() {
    this.displayedColumns = this.availableColumns
      .filter((col) => col.selected)
      .map((col) => col.value);
    this.selectAllColumns = this.availableColumns.every((col) => col.selected);
  }

  numbersFun(index: number): number {
    return index + 1 + this.paginator.pageIndex * this.paginator.pageSize;
  }
  

  // onViewClick(row: any) {
  //   this._workOrderService.selectedWorkOrder = row;
  //   this._router.navigate([`/work-order/view/${row.workOrderKey}`], {
  //     queryParams: { viewType: PAGE_VIEW_TYPE.VIEW }
  //   });
  // }

onViewClick(row: any) {
    const dialogRef = this.dialog.open(ProjectAndContractDetailsComponent, {
      width: '95%',
      maxWidth: '1100px',
      disableClose: true,
      data: row 
    });

    dialogRef.afterClosed().subscribe((result) => {
      // If result is true, it means the popup ALREADY saved the data successfully.
      if (result) {
        // Just refresh the table to show the new data!
        // (Added + 1 to fix the pagination refresh issue)
        this.searchDlpData(this.paginator.pageIndex + 1, this.searchControl.value || '');
      }
    });
  }

  export() {
    this.exportCsvService.export('DLP').subscribe((response: Blob) => {
      const data: Blob = new Blob([response], { type: 'text/csv;charset=utf-8' });
      saveAs(data, 'DLP-' + new Date() + '.csv');
    });
  }
}